"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Headline = void 0;
class Headline {
    constructor(obj) {
        // Take in an object, and assign every property from that
        // object onto this newly created object.
        for (const prop in obj) {
            if (prop === 'title') {
                this['headline'] = obj[prop];
                continue;
            }
            this[prop] = obj[prop];
        }
    }
}
exports.Headline = Headline;
//# sourceMappingURL=Headline.js.map